module.exports = ".divider{\n    margin-bottom: 10px;\n}\n\n.smallGry{\n  font-size: 14px;\n  color: grey;\n  display: inline-block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/my-reports/my-reports.component.css
// module id = ./src/app/my-reports/my-reports.component.css
// module chunks = main